import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminCustomers = lazy(() => import("@/pages/admin/AdminCustomers"));

export const Route = createFileRoute("/admin/kundregister")({
  validateSearch: (search: Record<string, unknown>) => ({
    kund: typeof search["kund"] === "string" ? (search["kund"] as string) : undefined,
  }),
  component: () => <AdminCustomers />,
});
